<template>
  <v-container text-xs-center>
    <v-layout row align-center>
      <v-flex>
        <h1 class="primary--text">{{ displayTitle }}</h1>

        <p>{{ displayContent }}</p>

        <router-link :to="{ name: 'ApplicationSelector' }">
          <v-btn :to="`/`" color="ml-0 primary" outlined>
            {{ $t('common.goToMainPage') }}
          </v-btn>
        </router-link>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'error-view',
  props: {
    title: {
      type: String,
      default: null,
    },
    content: {
      type: String,
      default: null,
    },
  },
  computed: {
    displayTitle() {
      return this.title || this.$t('errors.notFoundTitle');
    },
    displayContent() {
      return this.content || this.$t('errors.notFoundContent');
    },
  },
};
</script>
